import { render } from "./organizationUser.vue?vue&type=template&id=2634ae54&scoped=true"
import script from "./organizationUser.vue?vue&type=script&lang=js"
export * from "./organizationUser.vue?vue&type=script&lang=js"

import "./organizationUser.vue?vue&type=style&index=0&id=2634ae54&lang=scss&scoped=true"
import "./organizationUser.vue?vue&type=style&index=1&id=2634ae54&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2634ae54"]])

export default __exports__